<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div
    @keydown.esc="cancelModal"
    @click.self="cancelModal"
    class="modal fade"
    id="edit-user-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <form @submit.prevent>
      <div class="modal-dialog" style="text-align: left">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Editar usuário {{ user.id }}</h4>
            <div class="form-group">
              <label for="email">Apelido</label>
              <input id="nome" type="text" class="form-control" v-model="formData.apelido" autocomplete="apelido" />

              <span style="color: red" v-for="error in v$.apelido.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input id="email" type="email" class="form-control" v-model="formData.email" autocomplete="email" />

              <span style="color: red" v-for="error in v$.email.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <div class="form-group">
              <label for="password">Nova senha</label>
              <div class="input-group mb-3">
                <input :type="show_pass ? 'text' : 'password'" class="form-control" v-model="formData.nova_senha" />

                <div class="input-group-append">
                  <div
                    @click="show_pass = !show_pass"
                    class="input-group-text"
                    id="div-lock"
                    style="cursor: pointer; background-color: white; border-left: 0px solid #000000 !important"
                  >
                    <span id="lock" class="fas fa-eye"></span>
                  </div>
                </div>
              </div>

              <span v-if="formData.nova_senha" style="color: red" v-for="error in v$.nova_senha.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <button @click="update()" class="btn btn-primary btn-sm">Salvar</button>

            <button
              id="close_edit_user"
              style="margin-left: 5px"
              class="btn btn-danger btn-sm"
              data-toggle="modal"
              data-target="#edit-user-modal"
              @click="setEditarUsuario(false)"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { helpers } from "@vuelidate/validators";
import useVueLidate from "@vuelidate/core";
import { required, minLength } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  components: { Loading },

  props: ["user", "setEditarUsuario", "usuarioEditado"],

  data() {
    return {
      nome: "",
      email: "",
      senha: "",
      isLoading: false,
      my_container: {},
      show_pass: false,
    };
  },

  setup() {
    const formData = reactive({
      apelido: "",
      email: "",
      nova_senha: "",
    });

    const rules = computed(() => {
      let local_rules = {
        apelido: { required },
        email: { required },
      };

      if (formData.nova_senha) {
        local_rules.nova_senha = {
          required,
          minLength: minLength(5),
          validarSenha: helpers.withMessage(' A senha deve incluir um "@".', validarSenha),
        };
      }

      return local_rules;
    });

    const validarSenha = (value) => {
      if (value && value.includes("@")) {
        return true;
      } else {
        if (!value) {
          return true;
        }
        return false;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.formData.apelido = this.user.apelido;
    this.formData.email = this.user.email;
  },

  methods: {
    cancelModal() {
      this.setEditarUsuario(false);
    },

    async update() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          apelido: this.formData.apelido,
          senha: this.formData.nova_senha,
          email: this.formData.email,
        };

        console.log("Editando agora");
        console.log(data);

        axios
          .post(`/admin/usuarios_admin/update`, data)
          .then((response) => {
            this.isLoading = false;

            this.showSuccessMessage("Usuário atualizado!");
            this.usuarioEditado();
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
